// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"35766997","832":"4e39c336","850":"eeb3e9f9"}[chunkId] + ".chunk.css";
};